import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminShell from '../components/admin/AdminShell';
import AdminLegacyOverviewPage from './admin/AdminLegacyOverviewPage';
import AdminCommercialPlansPage from './admin/AdminCommercialPlansPage';
import AdminCommercialEntitlementsPage from './admin/AdminCommercialEntitlementsPage';
import AdminCommercialGuestPage from './admin/AdminCommercialGuestPage';
import AdminCommercialFirmPage from './admin/AdminCommercialFirmPage';
import AdminCommercialAiPage from './admin/AdminCommercialAiPage';
import AdminCommercialEnforcementPage from './admin/AdminCommercialEnforcementPage';
import AdminOperationsAiVisibilityPage from './admin/AdminOperationsAiVisibilityPage';
import AdminOperationsHealthPage from './admin/AdminOperationsHealthPage';
import AdminOperationsAsyncPage from './admin/AdminOperationsAsyncPage';
import AdminOrganizationsOfficesPage from './admin/AdminOrganizationsOfficesPage';
import AdminPlatformFlagsPage from './admin/AdminPlatformFlagsPage';
import AdminPlatformReadinessPage from './admin/AdminPlatformReadinessPage';
import AdminObservabilityPage from './admin/AdminObservabilityPage';
import AdminCommercialSnapshotPage from './admin/AdminCommercialSnapshotPage';
import AdminAuthLoginPage from './admin/AdminAuthLoginPage';

/**
 * Sprint 3.1.5 — Commercial Operating Control Center shell.
 * Legacy overview remains at `/admin` (index). Nested routes are additive.
 */
export default function AdminControlCenter() {
  return (
    <Routes>
      <Route element={<AdminShell />}>
        <Route index element={<AdminLegacyOverviewPage />} />
        <Route path="commercial/plans" element={<AdminCommercialPlansPage />} />
        <Route path="commercial/entitlements" element={<AdminCommercialEntitlementsPage />} />
        <Route path="commercial/guest-policies" element={<AdminCommercialGuestPage />} />
        <Route path="commercial/firm-mode" element={<AdminCommercialFirmPage />} />
        <Route path="commercial/ai-usage" element={<AdminCommercialAiPage />} />
        <Route path="commercial/enforcement-readiness" element={<AdminCommercialEnforcementPage />} />
        <Route path="commercial/snapshot" element={<AdminCommercialSnapshotPage />} />
        <Route path="operations/ai-visibility" element={<AdminOperationsAiVisibilityPage />} />
        <Route path="operations/operational-health" element={<AdminOperationsHealthPage />} />
        <Route path="operations/async-jobs" element={<AdminOperationsAsyncPage />} />
        <Route path="organizations/offices" element={<AdminOrganizationsOfficesPage />} />
        <Route path="platform/feature-flags" element={<AdminPlatformFlagsPage />} />
        <Route path="platform/auth-login" element={<AdminAuthLoginPage />} />
        <Route path="platform/readiness" element={<AdminPlatformReadinessPage />} />
        <Route path="observability" element={<AdminObservabilityPage />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Route>
    </Routes>
  );
}
